import { type ReactElement } from 'react'

export function Header (): ReactElement {
  return (
    <div className="flex justify-between">
      <h3 className="text-xl">Data Export Details</h3>
    </div>
  )
}
